'use client'

import Link from 'next/link'
import { useClock } from '../lib/use-clock'
import { LEGAL_NAME } from '../seo'

export function Footer() {
  const time = useClock()

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div>
            <div className="footer-brand">
              <span className="footer-brand-name">Payna</span>
            </div>
          </div>
          <div className="footer-meta">
            <span className="footer-location">
              San Francisco, CA
              {time && ` · ${time} PST`}
            </span>
          </div>
        </div>

        <div className="footer-nav">
          <div className="footer-nav-group">
            <span className="footer-nav-label">Company</span>
            <div className="footer-nav-links">
              {/* About and FAQ return when those pages exist; linking
                  them now would 404. */}
              <Link href="/docs" className="footer-nav-link">Docs</Link>
              <Link href="/blog" className="footer-nav-link">Blog</Link>
              <Link href="/changelog" className="footer-nav-link">Changelog</Link>
              <Link href="/security" className="footer-nav-link">Security</Link>
              <Link href="/contact" className="footer-nav-link">Contact</Link>
            </div>
          </div>
          <div className="footer-nav-group">
            {/* Free reference tables, and the only route to them from
                the rest of the site now the header "Reference" dropdown
                is gone (owner's call, 2026-09). The interactive API
                reference moved here from the top bar at the same time.
                Labels name the SUBJECT, not the audience: "Catastrophe
                adjusters" read like a group of people rather than a
                licensing table. */}
            <span className="footer-nav-label">Reference</span>
            <div className="footer-nav-links">
              <Link href="/docs/api" className="footer-nav-link">
                API reference
              </Link>
              <Link href="/licensing" className="footer-nav-link">
                State licensing reference
              </Link>
              <Link href="/licensing/mortgage" className="footer-nav-link">
                Mortgage licensing by state
              </Link>
              <Link
                href="/catastrophe-adjuster-licensing"
                className="footer-nav-link"
              >
                Catastrophe adjuster licensing by state
              </Link>
            </div>
          </div>
          <div className="footer-nav-group">
            <span className="footer-nav-label">Legal</span>
            <div className="footer-nav-links">
              <Link href="/terms-of-service" className="footer-nav-link">Terms</Link>
              <Link href="/privacy-policy" className="footer-nav-link">Privacy</Link>
            </div>
          </div>
          <div className="footer-nav-group">
            <span className="footer-nav-label">Connect</span>
            <div className="footer-nav-links">
              <a
                href="https://www.linkedin.com/company/payna"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-nav-link"
              >
                LinkedIn
              </a>
              <a href="mailto:hello@payna.com" className="footer-nav-link">
                Email
              </a>
            </div>
          </div>
        </div>

        {/* NON-AFFILIATION, SITE WIDE.

            This sentence already existed, word for word, but only on
            /docs. Meanwhile /seats names NMLS or NIPR ten times,
            /mortgage eight, the homepage seven, and none of them said
            who was speaking. Any page that could rank for a query
            containing "NMLS" has to be unmistakable about that, and
            the registries are trademarks belonging to other bodies.

            It lives in the footer rather than per page so a new page
            cannot be added without it. NIPR is named alongside the
            NMLS bodies because the insurance pages lean on it just as
            heavily. */}
        <p className="footer-affiliation">
          Payna is an independent compliance platform. It is not affiliated
          with, endorsed by, or operated by NMLS, the Conference of State
          Bank Supervisors, State Regulatory Registry LLC, NIPR, or the
          NAIC.
        </p>

        <div className="footer-bottom">
          <div className="footer-legal">
            <a href="/status" className="footer-legal-link">Status</a>
            <span className="footer-legal-sep">·</span>
            <a href="/terms-of-service" className="footer-legal-link">Terms of Service</a>
            <span className="footer-legal-sep">·</span>
            <a href="/privacy-policy" className="footer-legal-link">Privacy Policy</a>
          </div>
          {/* From the constant, not typed out. This read "Payna
              Technologies, Inc." until 2026-08-25, which is not the
              legal entity and contradicted the legal pages, the
              status page and the JSON-LD legalName on every single
              page of the site. */}
          <p className="footer-rights">
            © 2026 {LEGAL_NAME} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
